import { AbstractControl } from '@angular/forms';
import { InputValidationErrors } from '@libs/form/models';

export class CheckboxesValidator {
  public static required(control: AbstractControl): InputValidationErrors | null {
    if (
      control.value !== null &&
      typeof control.value === 'object' &&
      Object.values(control.value as Record<string, boolean>).some(
        (value: boolean) => value,
      )
    ) {
      return null;
    }

    return {
      required: true,
    };
  }
}
